let _LiteMode = 0
if (process.env) {
  switch (process.env.NODE_ENV) {
    case 'development-lite':
      _LiteMode = 1
      break
    case 'development':
      _LiteMode = 2
      break
    default:
      break
  }
}

export default _LiteMode



//////////////////
// WEBPACK FOOTER
// ./mode_1on1navi_web.js
// module id = 618
// module chunks = 1